/**
 * Type-safe wrapper function for Object.keys.
 * If a string or array is provided instead of an object,
 * it will return an array of indices. If a primitive type
 * is provided, an empty array will be returned.
 * @param {T} obj Object to get keys from, string/array to get indices from, or primitive.
 * @returns {(keyof T)[]} string[] Keys of object, indices of string/array (as strings), or [] for primitives.
 */
export function getKeys(obj) {
    // @ts-ignore
    return Object.keys(obj);
}
//# sourceMappingURL=getKeys.js.map